import { render } from "./control-toolbox.vue?vue&type=template&id=27c60b3f&scoped=true"
import script from "./control-toolbox.vue?vue&type=script&lang=js"
export * from "./control-toolbox.vue?vue&type=script&lang=js"

import "./control-toolbox.vue?vue&type=style&index=0&id=27c60b3f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c60b3f"]])

export default __exports__